import React from 'react';
import { StyleSheet } from 'react-native';
import { ButtonGroup, Text } from '@rneui/themed';
import { Modal } from '../../elements';
import { PlaybackStateFilter, Sort as SortOrder } from '@annunciate/core';
import { useWindowDimensions } from 'react-native';
const SORT_MAP = [
    { order: undefined, field: undefined, label: 'Default' },
    { order: SortOrder.ASC, field: 'availableAt', label: 'Oldest First' },
    { order: SortOrder.DESC, field: 'availableAt', label: 'Newest First' },
];
const FILTER_MAP = [
    { value: PlaybackStateFilter.ALL, label: 'All' },
    { value: PlaybackStateFilter.UNPLAYED, label: 'Unplayed' },
];
export const Sort = ({ isVisible, onToggleVisible, filter = PlaybackStateFilter.ALL, onFilterSelected = () => { }, sort = { order: undefined, field: undefined }, onSortSelected = () => { }, }) => {
    const { width } = useWindowDimensions();
    const isVertical = width < 500;
    return (React.createElement(Modal, { isVisible: isVisible, onCloseModal: onToggleVisible, onBackButtonPress: onToggleVisible, onBackdropPress: onToggleVisible, style: styles.modal },
        React.createElement(Text, { h3: true }, "Filter"),
        React.createElement(ButtonGroup, { vertical: isVertical, onPress: (idx) => onFilterSelected(FILTER_MAP[idx].value), selectedIndex: FILTER_MAP.findIndex(e => e.value === filter), buttons: FILTER_MAP.map(item => item.label), containerStyle: { marginHorizontal: 0 } }),
        React.createElement(Text, { h3: true }, "Sort"),
        React.createElement(ButtonGroup, { vertical: isVertical, onPress: (idx) => onSortSelected({
                order: SORT_MAP[idx].order,
                field: SORT_MAP[idx].field,
            }), selectedIndex: SORT_MAP.findIndex(e => (e.order === sort.order && e.field === sort.field)), buttons: SORT_MAP.map(item => item.label), containerStyle: { marginHorizontal: 0 } })));
};
const styles = StyleSheet.create({
    modal: {
        width: '100%',
        maxWidth: 700,
        margin: 'auto',
    },
});
//# sourceMappingURL=Sort.js.map